import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { TreeDataOption } from 'angular-slickgrid';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  trackSubscription: any = [];

  get roles() {
    let user = this.http.localStorageGetItem('admin_user');
    return user && user['role'];
  }

  constructor(private http: HttpService, private router: Router, private decimalPipe: DecimalPipe) {}

  public login(data) {
    data["email"] = this.encrypt(data["email"]);
    data["password"] = this.encrypt(data["password"]);
    return this.http.apiLogin('/auth/login', data);
  }

  downloadTemplate(uri, fileType) {
    const body = {
      path: uri,
      file_type: fileType
      // path: 'https://pa-web-file-uploads-private.s3.amazonaws.com/templateFiles/Data%2BCollection%2BUpload%2BTemplate%2Bv1.xlsxhttps://pa-web-file-uploads-private.s3.amazonaws.com/templateFiles/Data%2BCollection%2BUpload%2BTemplate%2Bv1.xlsx'
    };
    return this.http.apiPostFile(`/download/bomFile`, body);
  }

  encrypt(val) {
    return CryptoJS.AES.encrypt(val, environment.authSecretKey).toString();
  }

  decrypt(val) {
    if (val) {
      const decrypted = CryptoJS.AES.decrypt(val, environment.authSecretKey);
      try {
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/auth/login']);
        location.reload();
      }
    }
    return null;
  }

  msLogin(token){
    return this.http.msLogin('/auth/microsoftlogin', `Bearer ${token}`);
  }

  logout() {
    return this.http.apiPost('/auth/signout', {});
  }

  getHeaders(type, isInternalHeaders = false, companyId, labelType?) {
    if (this.roles === 'companyadmin') {
      return this.http.apiGetProtected(`/master/headers/${type}`);
    } else if (labelType) {
      return this.http.apiGetProtected(`/label-type/${labelType}/mappingHeaders/`)
    }
    else {
      return this.http.apiGetProtected(`/master/headers/${type}?companyId=${encodeURIComponent(companyId)}`);
    }
  }

  getPreferences(key: string) {
    if (this.roles === 'companyadmin') {
      return this.http.apiGetProtected(`/preference/${key}`);
    }
    return of([]);
  }
  savePreferences(payload) {
    if (this.roles === 'companyadmin') {
      return this.http.apiPost(`/preference`, payload);
    }
  }

  deletePreferenceView(type, payload) {
    if (this.roles === 'companyadmin') {
      return this.http.apiPost(`/preference/${type}`, payload);
    }
  }
  downloadErrorFile(id, file_type) {
    const body = {
      id: id,
      fileType: file_type
    };
    return this.http.apiPostFile(`/admin/errorFile/download`, body);
  }

  twoDecimal(row, cell, value, columnDef, dataContext) {
    const decimalPlaces = columnDef.decimalPlaces;
    const commaSeparator = columnDef.commaSeperator;
    const type = columnDef.id
    const n = Number(value);
    let result;
    // (decimalPlaces = 5) const fiveDecimalsArray = ['currentContractPrice', 'newContractPrice', 'currentContractPriceUSD', 'contract_price_1', 'contract_price_2', 'contract_price_3', 'contract_price_4', 'contract_price_5', 'contract_price_6', 'contract_price_7', 'contract_price_8', 'contract_price_9', 'contract_price_10', 'contract_price_11', 'contract_price_12', 'contract_price_13', 'contract_price_14', 'contract_price_15', 'contract_price_16', 'targetPrice', 'emsOrBuBaseLinePrice', 'publicPrice', 'benchmarkingPrice', 'lowestQuote', 'f2fPrice', 'newDirectPrice', 'lowestAvailablePrice', 'priorYearBid', 'supplierBidTotalCost', 'lowestQuoteContractPrice'];
    // (decimalPlaces = 2) const spendArray = ['combinedMPNVolumeSpend', 'currentContractSpend', 'newContractSpend', 'contractSpendDelta', 'emsBuBaselineSpend', 'emsBuNewContractSpend', 'emsBuBaselineSpendDelta']
    // (decimalPlaces = 4) const fourDecimalsArray = ['current_price', 'best_price', 'public_price', 'benchmarking_price', 'contract_price', 'partner_price', 'ppe_price', 'discounted_ppe_price', 'extended_price', 'approved_discounted_ppe_price', 'approved_ppe_price', 'ppe_price', 'discounted_ppe_price', 'discounted_public_price', 'current_unit_cost', 'proposed_unit_cost', 'newContractPrice', 'currentContractPrice', 'newDirectPrice', 'currentContractPriceUSD', 'vip_price', 'benchmarkingPrice', 'publicPrice', 'customTarget', 'lowestQuote', 'f2fPrice', 'priorYearBid', 'supplierBidTotalCost', 'distributorPublicPrice', 'lowestQuoteSelectedSupplier', 'lowestBidFcaCnv', 'lowestBidFcaCnv2', 'lowestBidFcaCnv3', 'awardPrice', 'duplicate_item_price', 'ems_po_price', 'duplicate_price', 'pa_ppe_price', 'emsBuBaselinePrice', 'baselinePrice'];
    // (decimalPlaces = 0) const savingsArray = ['benchmarking_savings', 'best_price_savings', 'negotiation_savings', 'ppe_savings', 'price_harmonization_contract_savings', 'price_harmonization_duplicate_items_savings', 'price_harmonization_partner_savings', 'public_price_savings', 'bom_spend', 'best_ppe_savings', 'approved_ppe_savings', 'pa_ppe_savings', 'discounted_public_price_savings', 'ems_po_price_savings', 'duplicate_items_savings', 'eau', 'spend', 'ppe_savings', 'lead_time', 'phr', 'negotiationSavings', 'submittedSavings', 'awardSavings', 'awardedCurrentSpend', 'awardedNewSpend', 'negotiationCurrentSpend', 'negotiationNewSpend', 'submittedCurrentSpend', 'submittedNewSpend'];
    // (decimalPlaces = 2) const forcedTwoDecimalArray = ['annualized_impact_in_percentage', 'markUpPercent', 'markUpPercentage', 'submittedPercentSavings','awardedPercentSavings', 'negotiationPercentSavings'];
    const stringFields = ['mfgPn', 'emsPn', 'emrBuPn', 'primaryMfgPn', 'ems_part_number', 'primaryMpn', 'primaryRemarks', 'lowestAvailablePxRemarks', 'businessUnit', 'emsName', 'primaryMfg', 'mpn', 'matched_mpn']
    const numericCols = ['contractSpendPercentageDelta', 'currentContractSpend', 'percentAdder', 'combinedMPNVolume', 'onHandQty', 'baselinePrice', 'annual_forecast'];
    if (n && Number(n) === n && !stringFields.includes(type)) {
      if (n % 1 !== 0) {
        result = decimalPlaces === 0 ? Math.ceil(Number(n)).toLocaleString() : decimalPlaces ? commaSeparator ? this.decimalPipe.transform(Number(n), `1.${decimalPlaces}-${decimalPlaces}`) : n.toFixed(decimalPlaces) : n.toFixed(2);
      } else {
        result = decimalPlaces === 0 ? Math.floor(Number(n)).toLocaleString() : decimalPlaces ? commaSeparator ? this.decimalPipe.transform(Number(n), `1.${decimalPlaces}-${decimalPlaces}`) : n.toFixed(decimalPlaces) : typeof (value) === 'number' ? value : value.toLocaleString();
      }
    } else if (n && Number(n) === n && stringFields.includes(type)) {
      if (decimalPlaces === 0 && stringFields.includes(type)) {
        result = Math.ceil(Number(n)).toLocaleString();
      } else {
        result = value;
      }
    } else if (typeof (value) === 'string') {
      result = (value === 're_run_needed') ? 'Needs Re-run' : (value === '') ? "--" : value;
    } else if (numericCols.includes(value)) {
      result = value;
    } else {
      result = "--";
    }
    return `<span class="${(dataContext['isMatchingAccepted'] === false && dataContext['availableManufacturer'] && dataContext['availableManufacturer'].length) ? 'highlight' : ''}">${result ? result : '--'}</span>`;
  }

  replaceBUDataBomIq(data) {
    let tableData = data;
    for (let i = 0; i < data['data']['length']; i++) {
      let buList = [];
      let supplierName = '';
      let supplierSite = '';
      let productName = [];
      let uploadedBy = '';
      buList = tableData['data'] && tableData['data'][i] && tableData['data'][i]['businessUnits'] && tableData['data'][i]['businessUnits'].length ? tableData['data'][i]['businessUnits'].map(rs => rs.unit_name) : [];
      supplierName = tableData['data'] && tableData['data'][i] && tableData['data'][i]['bom_supplier'] ? tableData['data'][i]['bom_supplier'] : '';
      supplierSite = tableData['data'] && tableData['data'][i] && tableData['data'][i]['bom_supplier_site'] ? tableData['data'][i]['bom_supplier_site'] : '';
      productName = tableData['data'] && tableData['data'][i] && tableData['data'][i]['products'] && tableData['data'][i]['products'].length ? tableData['data'][i]['products'].map(rs => rs.name) : [];
      const firstName = tableData['data'] && tableData['data'][i] && tableData['data'][i]['user'] && tableData['data'][i]['user'].first_name ? tableData['data'][i]['user'].first_name : '';
      const lastName = tableData['data'] && tableData['data'][i] && tableData['data'][i]['user'] && tableData['data'][i]['user'].last_name ? tableData['data'][i]['user'].last_name : '';
      uploadedBy = firstName + ' ' + lastName;
      if (tableData && tableData['data'] && tableData['data'][i]) {
        tableData['data'][i] = {
          ...tableData['data'][i],
          business_unit: buList.join(', '),
          uploaded_by: uploadedBy,
          product_name: productName.join(', '),
          bom_supplier: supplierName,
          bom_supplier_site: supplierSite,
        };
      };
    };
    return tableData;
  }

  updateMultiLevelGridOptions() : TreeDataOption {

    // let gridOps = JSON.parse(JSON.stringify(gridOptions));

    const gridOps = {};
    // gridOps['enableTreeData'] = true; // you must enable this flag for the filtering & sorting to work as expected
    return {
      columnId: 'bom_number',
      parentPropName: 'parent_id',
      // this is optional, you can define the tree level property name that will be used for the sorting/indentation, internally it will use "__treeLevel"
      levelPropName: 'level',
      indentMarginLeft: 15,
      initiallyCollapsed: true,

      // you can optionally sort by a different column and/or sort direction
      // this is the recommend approach, unless you are 100% that your original array is already sorted (in most cases it's not)
      // initialSort: {
      //   columnId: 'bom_number',
      //   direction: 'ASC'
      // },
      // we can also add a custom Formatter just for the title text portion
      titleFormatter: (_row, _cell, value, _def, dataContext) => {
        const bomiqStatusCheck = (dataContext['checks_status'] && !(dataContext['checks_status'] === 'completed' || dataContext['checks_status'] === 're_run_needed')) ? true : false;
        let prefix = '';
        _def['cssClass'] = `textAlignLeft`;
        if (dataContext.level > 0) {
          prefix = `<span class="mdi mdi-subdirectory-arrow-right mdi-v-align-sub color-se-secondary"></span>`;
        }

        if (bomiqStatusCheck) {
          return `${value} <span class="highlight leftAlign">Analysis in progress, a notification will be sent when complete <button class="btn cust-btn">Check Status</button></span>`
        }
        return `${prefix}<span class="bold multi-tree-data-col ${!bomiqStatusCheck ? 'cp hyper-link' : ''}">${value}</span>`;
      },
    };
    // gridOps['multiColumnSort'] = false; // multi-column sorting is not supported with Tree Data, so you need to disable it

    // return gridOps;
  }

  updateMultiLevelGridOptionsForItemList(): TreeDataOption {

    return {
      columnId: 'item_number',
      parentPropName: 'parent_id',
      // this is optional, you can define the tree level property name that will be used for the sorting/indentation, internally it will use "__treeLevel"
      levelPropName: 'level',
      indentMarginLeft: 15,
      initiallyCollapsed: true,

      // we can also add a custom Formatter just for the title text portion
      titleFormatter: (_row, _cell, value, _def, dataContext) => {
        //custom logic starts 
        const uniqueId = dataContext['rowid'] ? dataContext['rowid'] : dataContext['_id'] ? dataContext['_id'] : dataContext['id'] ? dataContext['id'] : dataContext['list_name'] ? dataContext['list_name'] : dataContext['itemNumber'] ? dataContext['itemNumber'] : dataContext['item_number'] ? dataContext['item_number'] : '';
        const itemNumberFormatting = `<span data-manufacture = ${dataContext.manufacture ? dataContext.manufacture : dataContext.manufacturer_name} data-id=${uniqueId} data-mpn = ${dataContext.mpn} data-mpn_1 = ${dataContext.mpn_1} data-column = ${_def.id} class="cp hyper-link item_number" ${_def.id}
    ${((dataContext['isMatchingAccepted'] === false && dataContext['availableManufacturer'] && dataContext['availableManufacturer'].length)) ? 'highlight' : ''}">${value ? value : '--'}</span>`;
        //custom logic ends 
        return itemNumberFormatting;
      },
    };
  }

  removeSubscriptionWhichIsCompleteFromList() {
    const pos = this.trackSubscription.findIndex(x => x['closed']);
    if (pos > -1) {
      this.trackSubscription.splice(pos, 1);
    }
  }

  getStructuredTableData(phsData) {
    if (phsData) {
      for (let i = 0; i < phsData['data']['length']; i++) {
        if (phsData['data'][i]) {
          phsData['data'][i] = {
            ...phsData['data'][i],
            phr: phsData['data'][i]['phr'] ? phsData['data'][i]['phr'] : 0,
          };
        }
      }
    }
    return phsData;
  }

  downloadPartListFile(uri) {
    const body = {
      path: uri
    };
    return this.http.apiPostFile(`/download/partListFile`, body);
  }

  downloadBomFile(uri, file_type, userData) {
    const body = {
      path: uri,
      file_type: file_type,
      company_id: userData
    };
    return this.http.apiPostFile(`/download/bomFile`, body);
  }

  handleOAuthError(params: any): boolean {
    if (params['error']) {
      const msg = params['error_description'] || 'Authentication failed.';
      this.router.navigate(['/oAuth/error'], {
        queryParams: {
          error: params['error'],
          error_description: msg || params['msg']
        }
      });
      return true;
    }
    return false;
  }
}
